import React, {Component} from 'react';
import {client} from '../../Client';
import {Button, Checkbox, Form, Input, Message} from 'semantic-ui-react'
import Moment from 'moment';
import {arrayToCombo, convertNullToEmptyString, optionsStatoGara} from '../../Helpers'
import ErrorMessage from '../ErrorMessage'
import {Redirect} from 'react-router-dom';
import 'moment/locale/it.js';
import { DatePickerInput } from 'rc-datepicker';
import 'rc-datepicker/lib/style.css';
import PropTypes from 'prop-types';
import RubricaSearchModal from "../rubrica/RubricaSearchModal";



class GareForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: this.props.match.params.id, // Se undefined siamo in insert, altr in update
            inUpdate: this.props.match.params.id !== undefined,
            fields: this.getEmptyFields(),
            dropdownTipoLoading: false,
            fieldErrors: {},
            fieldErrorsText: [],
            inError: false,
            _loading: false,
            errorTitle: '',
            saveSuccess: false,
            cancelSuccess: false,
            error: null,
            itemSaved: null,
            tipiGaraList: []
        };

        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleCancel = this.handleCancel.bind(this)
        this.formIsValid = this.formIsValid.bind(this)
        this.onInputChange = this.onInputChange.bind(this)
        this.onInputChangeUppercase = this.onInputChangeUppercase.bind(this)
        this.onInputCheckboxChange = this.onInputCheckboxChange.bind(this)
        this.onSelectSoggetto = this.onSelectSoggetto.bind(this)
        this.comboTipiGaraLoaded = this.comboTipiGaraLoaded.bind(this)
        this.comboTipiGaraLoadedError = this.comboTipiGaraLoadedError.bind(this)
    }

    componentDidMount() {
        if (this.state.inUpdate)
        {
            this.setState({ _loading: true });
            client.loadGara(this.state.id).then(
                (response) => {
                    if (response.ok){
                        response.json().then((gara) => {
                            let fields = convertNullToEmptyString(gara);
                            fields.tipo = fields.tipo === undefined ? null : fields.tipo.idTipoGara;

                            this.setState({ _loading: false, fields: fields,  fieldErrors: {},
                                fieldErrorsText: [], inError: false, error: null, itemSaved: gara});
                            this.comboTipiGara();
                            this.forceUpdate();
                        })
                    }
                    else if (response.status === 401)
                    {
                        this.props.history.push("/login")
                    }
                    else
                    {
                        response.json().then((errore) => {
                            let fieldErrorsText = []
                            let fieldErrors = {}
                            this.setState({
                                _loading: false,
                                fieldErrors: fieldErrors,
                                fieldErrorsText: fieldErrorsText,
                                errorTitle: '',
                                error: {title: errore.title, msg: errore.msg},
                                inError: true
                            });
                        });

                    }
            }).catch((error) => {

                let fieldErrorsText = []
                let fieldErrors = {}
                this.setState({
                    _loading: false,
                    fieldErrors: fieldErrors,
                    fieldErrorsText: fieldErrorsText,
                    errorTitle: '',
                    error: {title: "Errore di rete imprevisto", msg: error.message},
                    inError: true
                });

            });
        }
        else
        {
            this.comboTipiGara();
        }
    }

    getEmptyFields() {
        let ora = Moment().format("YYYY-MM-DD");
        return {
            'codice': '',
            'nome': '',
            'dataReg': ora,
            'ragioneSociale' : '',
            'indirizzo' : '',
            'cap' : '',
            'citta' : '',
            'provincia' : '',
            'stato' : '',
            'piva' : '',
            'cfisc' : '',
            'email' : '',
            'pec' : '',
            'web' : '',
            'fax' : '',
            'letteraIncarico' : '',
            'letteraPrivacy' : '',
            'idCommessa': null,
            'idsoggetto': null,
            'codCup' : '',
            'codDestUnivoco' : '',
            'partecipato' : false,
            'affidato' : false,
            'statoGara' : 'IP',
            'presentazione': '',
            'sopralluogo': '',
            'chiarimenti': '',
        }
    }


    comboTipiGara(){
        this.setState({ dropdownTipoLoading: true });
        client.loadTipiGaraList().then(this.comboTipiGaraLoaded).catch(this.comboTipiGaraLoadedError);
    }

    comboTipiGaraLoaded(response){

        if (response.ok)
        {
            response.json().then((data)=>{
                this.setState({
                    dropdownTipoLoading: false,
                    error: null,
                    tipiGaraList: arrayToCombo(data.items, "idTipoGara", "descrizione", "idTipoGara")
                })
            })
        }
        else if (response.status === 401)
        {
            this.props.history.push("/login")
        }            else
        {
            response.json().then((errore) => {
                let fieldErrorsText = []
                let fieldErrors = {}
                this.setState({
                    dropdownTipoLoading: false,
                    fieldErrors: fieldErrors,
                    fieldErrorsText: fieldErrorsText,
                    errorTitle: '',
                    error: {title: errore.title, msg: errore.msg},
                    inError: true
                });
            });
        }
    }

    comboTipiGaraLoadedError(error){
        let fieldErrorsText = []
        let fieldErrors = {}
        this.setState({
            dropdownTipoLoading: false,
            fieldErrors: fieldErrors,
            fieldErrorsText: fieldErrorsText,
            errorTitle: '',
            error: {title: "Errore di rete imprevisto", msg: error.message},
            inError: true
        });
    }

    formIsValid(formData) {
        // Validazione dati
        let fieldErrorsText = []
        let fieldErrors = {}

        // Validazione date
        if (formData.dataReg === "Invalid date"){
            fieldErrors["dataReg"] = true;
            fieldErrorsText.push("La data di Registrazione non è nel formato corretto (gg/mm/aaaa)");
        }

        if (formData.nome !== "")
        {
            if ( (/^[\w\- ]+$/.test(formData.nome)) === false ){
                fieldErrors["nome"] = true;
                fieldErrorsText.push("Nome della Gara: Utilizzare solo caratteri alfanumerici e i caratteri speciali seguenti:  '-', ' '.");
            }
        }

        if (Object.keys(fieldErrors).length > 0)
        {
            this.setState({
                fieldErrors: fieldErrors,
                fieldErrorsText: fieldErrorsText,
                errorTitle:"La form contiene errori",
                inError: true
            })
            return false;
        }
        return true;
    }

    handleCancel(e) {

        e.preventDefault();
        this.setState({cancelSuccess: true})
    }

    handleSubmit(e) {
        e.preventDefault();
        let formData = this.state.fields;

        // Validazione form
        if (!this.formIsValid(formData)){
            return;
        }

        // Salvataggio sul server
        delete formData["stato-search"];
        this.setState({_loading: true});
        client.saveGara(
            formData,
            this.state.fields.idGara
        ).then((response) => {
            if (response.ok){
                response.json().then((data) => {
                    let fields = this.state.fields;
                    fields["idGara"] = data.idGara;
                    this.setState({
                        _loading: false,
                        inError: false,
                        fieldErrors: {},
                        fieldErrorsText: [],
                        saveSuccess: true,
                        successTitle: "Salvataggio gara",
                        successText: "La gara è stata salvata correttamente",
                        fields: fields,
                        itemSaved: data,
                    });
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((error) => {
                    let fieldErrorsText = []
                    let fieldErrors = {}

                    if (error.errors !== undefined){
                        Object.keys(error.errors).map((item) => {
                            fieldErrors[item] = true;
                            fieldErrorsText = fieldErrorsText.concat(item + ":" +error.errors[item]);
                            return 0;
                        });
                    }
                    else {
                        fieldErrorsText = [error.message]
                    }
                    this.setState({
                        _loading: false,
                        fieldErrors: fieldErrors,
                        fieldErrorsText: fieldErrorsText,
                        errorTitle:error.title,
                        inError: true
                    });
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                fieldErrors: {},
                fieldErrorsText: [error.message],
                errorTitle: "Errore di rete imprevisto",
                inError: true
            });
        });
    }

    onInputChange(a1, {name, value}){

        if (name !== undefined)
        {
            const fields = this.state.fields;
            fields[name] = value;
            this.setState({ fields });
        }
    }

    onInputCheckboxChange(a1, {name, checked}){
        if (name !== undefined)
        {
            const fields = this.state.fields;
            fields[name] = checked;
            this.setState({ fields });
        }
    }

    onInputChangeUppercase(a1, {name, value}){
        if (name !== undefined)
        {
            const fields = this.state.fields;

            fields[name] = value.toUpperCase();

            this.setState({ fields });
        }
    }

    onSelectSoggetto(soggetto){
        const fields = this.state.fields;

        const dip = soggetto.idDipartimento;
        const org = dip.idOrganizzazione;

        console.log("SOGG SEL: ", soggetto, dip, org);

        fields["idSoggetto"]=soggetto.idSoggetto;
        if(org.nome){
            fields["ragioneSociale"]= org.nome;
            fields["indirizzo"]=org.indirizzo;
            fields["stato"]=org.stato;
            fields["cap"]=org.cap;
            fields["citta"]=org.citta;
            fields["provincia"]=org.provincia;
            fields["piva"]=org.piva;
            fields["cfisc"]=org.cfisc;
            fields["fax"]=org.fax;
            fields["telefono1"]=org.telefono1;
            fields["telefono2"]=org.telefono2;
            fields["cellulare"]=org.cellulare;
            fields["email"]=org.email;
            fields["pec"]=org.pec;
            fields["web"]=org.web;
        }
        else {
            fields["ragioneSociale"]=  soggetto.nomeCognome;
            fields["indirizzo"]=soggetto.indirizzo;
            fields["stato"]=soggetto.stato;
            fields["cap"]=soggetto.cap;
            fields["citta"]=soggetto.citta;
            fields["provincia"]=soggetto.provincia;
            fields["piva"]=soggetto.piva;
            fields["cfisc"]=soggetto.cfisc;
            fields["fax"]=soggetto.fax;
            fields["telefono1"]=soggetto.telefono1;
            fields["telefono2"]=soggetto.telefono2;
            fields["cellulare"]=soggetto.cellulare;
            fields["email"]=soggetto.email;
            fields["pec"]=soggetto.pec;
            fields["web"]=soggetto.web;
        }
        this.setState({ fields });
    }

    render() {

        let btnSalva = null;
        if (client.getCurrentUser().isrolegarew){
            btnSalva = <div className="left aligned eight wide column">
                <Button primary type='submit'><i className="save icon"/> Salva</Button>
            </div>
        }else{
            btnSalva = <div className="left aligned eight wide column">
                <Button secondary disabled type='submit'><i className="save icon"/>Non hai i diritti per salvare</Button>
            </div>
        }
        
        if (this.state.error != null)
        {
            return (<ErrorMessage title={this.state.error.title} msg={this.state.error.msg} />)
        }

        let formInError = this.state.fieldErrorsText.length > 0;

        if (this.state.saveSuccess  || this.state.cancelSuccess){

            return <Redirect to={ {
                pathname: '/app/gare/list',
                state: {
                    from: this.props.location,
                    item: this.state.itemSaved
                },
            }}/>
        }
        let titleMsg = this.state.inUpdate ?
            <h3 className="ui block attached top header"><i className="edit icon"></i> Modifica Gara/Offerta - Informazioni di base</h3>
            :
            <h3 className="ui block attached top header"><i className="add square icon"></i> Nuova Gara/Offerta - Informazioni di base</h3>

        const url = new URL(window.location.href);            
        let urlRubrica = url.origin + "/app/rubrica/list";

        return (
            <div>
            <Form onSubmit={this.handleSubmit} error={formInError} loading={this.state._loading} success={this.state.saveSuccess}>
                {titleMsg}
                <div className="ui attached segment">
                <Form.Group widths="4">
                    <Form.Field width={2} label="Anno" required={false} disabled={true} control={Input} name="anno" autoComplete="nope" value={this.state.fields.anno} onChange={this.onInputChange} />
                    <Form.Field width={2} label="Codice" required={false} disabled={true} control={Input} name='codice'  autoComplete="nope"  title="Inserire solo lettere e/o numeri, underscore e linea" pattern="[A-Z0-9_-]+"  placeholder='Codice'  value={this.state.fields.codice}  onChange={this.onInputChangeUppercase} error={this.state.fieldErrors["codice"]}/>
                    <Form.Field width={8} label="Nome" required={false}  control={Input} name='nome' autoComplete="nope"  placeholder='Nome gara' maxLength="100"  value={this.state.fields.nome}  onChange={this.onInputChange}/>
                    <Form.Dropdown width={4} label='Stato' name='statoGara' fluid selection options={optionsStatoGara} value={''+this.state.fields.statoGara} onChange={this.onInputChange}/>
                </Form.Group>
                <Form.Group widths="4">
                    <Form.Field width={4}>
                        <label>Data registrazione</label>
                        <DatePickerInput
                            onChange={(jsDate, dateString) => {this.onInputChange(null, {name: 'dataReg', value: dateString === "Invalid date"?"":dateString})}}
                            value={this.state.fields.dataReg}
                            displayFormat='DD/MM/YYYY'
                            returnFormat='YYYY-MM-DD'
                        />
                    </Form.Field>
                    <Form.Field width={4} label="Presentazione entro il" required={false}  control={Input} name='presentazione' autoComplete="nope"  placeholder='' maxLength="255"  value={this.state.fields.presentazione}  onChange={this.onInputChange}/>
                    <Form.Field width={4} label="Sopralluogo" required={false}  control={Input} name='sopralluogo' autoComplete="nope"  placeholder='' maxLength="255"  value={this.state.fields.sopralluogo}  onChange={this.onInputChange}/>
                    <Form.Field width={4} label="Chiarimenti" required={false}  control={Input} name='chiarimenti' autoComplete="nope"  placeholder='' maxLength="255"  value={this.state.fields.chiarimenti}  onChange={this.onInputChange}/>
                </Form.Group>
                    <em >Nome: Utilizzare solo caratteri alfanumerici e i caratteri speciali seguenti: meno (-) blank ( )</em>
                <Form.Group widths="4">
                    <Form.Dropdown width={4} label="Tipo di Gara" loading={this.state.dropdownTipoLoading} placeholder='Tipo gara' name='tipo' fluid search selection options={this.state.tipiGaraList} value={this.state.fields.tipo}
                                   onChange={this.onInputChange} error={this.state.fieldErrors["tipo"]} />
                    <Form.Field width={4} label="Codice Destinatario / Codice Univoco (SDI/IPA)" required={false} disabled={false} control={Input} maxLength="7" name='codDestUnivoco'  autoComplete="nope"  title="Inserire solo lettere e/o numeri" pattern="[A-Z0-9]+"  placeholder='Codice'  value={this.state.fields.codDestUnivoco}  onChange={this.onInputChangeUppercase} error={this.state.fieldErrors["codDestUnivoco"]}/>
                    <Form.Field width={4} label="Codice Unico di Progetto (CUP)" required={false} disabled={false} control={Input} name='codCup' maxLength="15"  autoComplete="nope"  title="Inserire solo lettere e/o numeri" pattern="[A-Z0-9]+"  placeholder='Codice'  value={this.state.fields.codCup}  onChange={this.onInputChangeUppercase} error={this.state.fieldErrors["codCup"]}/>
                    <Form.Field width={2} >
                        <label>Si è partecipato</label>
                        <Checkbox name="partecipato" defaultIndeterminate={false} toggle checked={this.state.fields.partecipato} onChange={this.onInputCheckboxChange} />
                    </Form.Field>
                    <Form.Field width={2} >
                        <label>Affidato</label>
                        <Checkbox name="affidato" defaultIndeterminate={false} toggle checked={this.state.fields.affidato} onChange={this.onInputCheckboxChange} />
                    </Form.Field>
                </Form.Group>

                </div>
                <h3 className="ui block attached header">Cliente &nbsp;&nbsp;
                    <small><RubricaSearchModal
                        title={"Importa dalla rubrica"}
                        onSelectSoggetto={this.onSelectSoggetto}
                    >
                        <a href={"#"}>Importa dalla rubrica</a>
                    </RubricaSearchModal></small>
                    &nbsp;&nbsp;&nbsp;
                    <small>
                        <a target='_blank' href={urlRubrica}>Apri rubrica in una nuova scheda</a> 
                    </small>
                </h3>
                <div className="ui attached segment">

                <Form.Input label='Ragione sociale' required={false} name='ragioneSociale'  autoComplete="nope"  placeholder='Ragione sociale cliente' maxLength={255} value={this.state.fields.ragioneSociale} onChange={this.onInputChange}/>
                <Form.Input label='Indirizzo' name='indirizzo'  autoComplete="nope" placeholder='Via/Piazza...' maxLength={255} value={this.state.fields.indirizzo} onChange={this.onInputChange}/>
                <Form.Group widths='4'>
                    <Form.Input label='Stato' name='stato' placeholder='' autoComplete="nope"  width={1} maxLength={2} value={this.state.fields.stato} onChange={this.onInputChangeUppercase} />
                    <Form.Input label='CAP' name='cap'  autoComplete="nope" placeholder='' width={2} maxLength={10} value={this.state.fields.cap} onChange={this.onInputChange} />
                    <Form.Input label='Città' name='citta' autoComplete="nope"  placeholder='' width={11} maxLength={255} value={this.state.fields.citta} onChange={this.onInputChangeUppercase}/>
                    <Form.Input label='Provincia' name='provincia'  autoComplete="nope" placeholder='' width={2} maxLength={2} value={this.state.fields.provincia} onChange={this.onInputChangeUppercase}/>
                </Form.Group>
                <Form.Group widths='3'>
                    <Form.Input label='P.IVA' name='piva' autoComplete="nope"  placeholder='' maxLength={11}  value={this.state.fields.piva} onChange={this.onInputChangeUppercase}/>
                    <Form.Input label='Codice Fiscale' name='cfisc'  autoComplete="nope" placeholder='' maxLength={16}  value={this.state.fields.cfisc} onChange={this.onInputChangeUppercase}/>
                    <Form.Input label='Fax'  name='fax'  maxLength={30} autoComplete="nope" value={this.state.fields.fax} error={this.state.fieldErrors["fax"]} onChange={this.onInputChange}/>
                </Form.Group>
                <Form.Group widths='3'>
                    <Form.Input label='Telefono 1' name='telefono1' autoComplete="nope"  placeholder='' maxLength={30}  value={this.state.fields.telefono1} error={this.state.fieldErrors["telefono1"]} onChange={this.onInputChange}/>
                    <Form.Input label='Telefono 2' name='telefono2'  autoComplete="nope" placeholder='' maxLength={30}  value={this.state.fields.telefono2} error={this.state.fieldErrors["telefono2"]} onChange={this.onInputChange}/>
                    <Form.Input label='Cellulare'  name='cellulare'  maxLength={30} autoComplete="nope" value={this.state.fields.cellulare} error={this.state.fieldErrors["cellulare"]} onChange={this.onInputChange}/>
                </Form.Group>
                <Form.Group widths='3'>
                    <Form.Input label='Email'  name='email'  autoComplete="nope" width={6} value={this.state.fields.email} error={this.state.fieldErrors["email"]} onChange={this.onInputChange}/>
                    <Form.Input label='PEC'  name='pec' autoComplete="nope" width={4} value={this.state.fields.pec} error={this.state.fieldErrors["pec"]} onChange={this.onInputChange}/>
                    <Form.Input label='Sito web' name='web'  autoComplete="nope" width={10} value={this.state.fields.web} error={this.state.fieldErrors["web"]} onChange={this.onInputChange}/>
                </Form.Group>
                </div>
                <h3 className="ui block attached header">Note</h3>
                <div className="ui attached segment">
                    <Form.TextArea name='note' label='' placeholder='' rows='4' value={this.state.fields.note} onChange={this.onInputChange}/>
                </div>
                <Message
                    error
                    header={this.state.errorTitle}
                    list={this.state.fieldErrorsText}
                />
                <Message
                    success
                    header={this.state.successTitle}
                    content={this.state.successText}
                    icon={"smile"}
                />

                <p></p>
                <div className="ui grid">
                    <div className="right aligned eight wide column">
                        <a onClick={this.handleCancel} className="ui right floated  secondary  button"><i className="undo icon"/>Annulla</a>
                    </div>
                    {btnSalva}
                </div>

            </Form>
            </div>
        )
    }
}

GareForm.contextTypes = {
    router: PropTypes.object
}

export default GareForm;




/** WEBPACK FOOTER **
 ** ./src/components/gare/GareForm.js
 **/